import { render, staticRenderFns } from "./PersoFix.vue?vue&type=template&id=2bdb4750&scoped=true&"
import script from "./PersoFix.vue?vue&type=script&lang=ts&"
export * from "./PersoFix.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb4750",
  null
  
)

export default component.exports